/* Geekline global events*/
export const types = {
  orders: {
    GLGE_ORDER_BASKET_CHANGED: 'glge-order-basket-changed', // TODO: remove deprecated
    GLGE_ADD_2_BASKET: 'glge-add-2-basket'
  }
}

export const bus = {
  onGlobal: (et, handler) => {
    // window.addEventListener(et, handler)
    bus.on(window, et, handler)
  },
  offGlobal: (et, handler) => {
    // window.removeEventListener(et, handler)
    bus.off(window, et, handler)
  },
  emitGlobal: (et, detail = {}) => {
    // window.dispatchEvent(new CustomEvent(et, { detail }))
    bus.emit(window, et, detail)
  },
  on: (tg, et, handler) => {
    tg.addEventListener(et, handler)
  },
  off: (tg, et, handler) => {
    tg.removeEventListener(et, handler)
  },
  emit: (tg, et, detail = {}) => {
    tg.dispatchEvent(new CustomEvent(et, { detail }))
  }
}
